import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Grid2,
  CircularProgress,
} from "@mui/material";
import { Iconify } from "../Minimal/src/components/iconify";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import { API_URL } from "../Config";
import config from "../common/Config";
import printNewSalesInvoice from "./printNewSalesInvoice";
import printNewSalesInvoice_tsc from "./printNewSalesInvoice_tsc";
import printNewSalesInvoice_knm from "./printNewSalesInvoice_knm";
import printNewSalesInvoice_sdm from "./printNewSalesInvoice_sdm";
import printNewQuoteInvoice from "./printNewQuoteInvoice";
import printNewQuoteInvoice_sdm from "./printNewQuoteInvoice_sdm";
import printNewSalesInvoice_rhv from "./printNewSalesInvoice_rhv";
import generateSummaryPDF_atr from "./generateSummaryPDF_atr";
import "../common/commonStyles.css";

const NewSalesInvoice = () => {
  const { orderId } = useParams();
  const [shopDetails, setShopDetails] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [productDetails, setProductDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalVal, setTotalVal] = useState({
    totalstd: 0,
    totalzeroGoods: 0,
    totalTax: 0,
    orderDiscount: 0,
    grandTotal: 0,
    totalCess: 0,
  });

  const accessToken = localStorage.getItem("accessToken");
  const company_tax_type = localStorage.getItem("company_tax_type") || "VAT";
  const currencySymbol = localStorage.getItem("currencySymbol") || "£";
  const showCessRate = localStorage.getItem("showCessRate");

  const fetchInvoice = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("orderId", orderId);
    try {
      const response = await fetch(`${API_URL}/ws-new-sales-details`, {
        method: "POST",
        headers: { authorization: `Bearer ${accessToken}` },
        body: formData,
      });
      if (!response.ok) throw new Error("Failed to fetch order");
      const data = await response.json();

      setShopDetails(data.details.shop_details || []);
      setOrderDetails(data.details.orderDetails?.[0] || null);
      setProductDetails(data.details.product_details || []);

      const products = data.details.product_details || [];
      const order = data.details.orderDetails?.[0] || {};

      const totalstd_without_contract = products
        .filter((item) => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === "N")
        .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);
      const totalzeroGoods_without_contract = products
        .filter((item) => (item.item_tax === "0.00" || item.item_tax === null) && item.isContractPriceApplied === "N")
        .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);
      const totalTax_without_contract = products
        .filter((item) => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === "N")
        .reduce((sum, item) => sum + parseFloat(item.item_tax || 0), 0);

      const totalstd_with_contract = products
        .filter((item) => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === "Y")
        .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);
      const totalzeroGoods_with_contract = products
        .filter((item) => (item.item_tax === "0.00" || item.item_tax === null) && item.isContractPriceApplied === "Y")
        .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);
      const totalTax_with_contract = products
        .filter((item) => item.item_tax !== "0.00" && item.item_tax != null && item.isContractPriceApplied === "Y")
        .reduce((sum, item) => sum + parseFloat(item.item_tax || 0), 0);

      const totalstd = totalstd_without_contract + totalstd_with_contract;
      const totalzeroGoods = totalzeroGoods_without_contract + totalzeroGoods_with_contract;

      let totalDiscountOnVat = parseFloat(order.over_all_discount) || 0;
      if (order.percentage != null) totalDiscountOnVat += parseFloat(order.percentage);
      const discountedVatWithoutContract = totalTax_without_contract - (totalTax_without_contract * totalDiscountOnVat) / 100;
      const totalTax = discountedVatWithoutContract + totalTax_with_contract;

      const orderDiscount = parseFloat(order.order_discount) || 0;
      const orderDiscount1 = parseFloat(order.order_discount1) || 0;
      const over_all_discount = parseFloat(order.over_all_discount) || 0;
      const over_all_amount = parseFloat(order.over_all_amount) || 0;
      const totalWithoutContract = totalzeroGoods_without_contract + totalstd_without_contract;
      let InvDiscount = over_all_discount > 0 ? (totalWithoutContract * over_all_discount) / 100 : 0;

      let totalCess = 0;
      if (showCessRate === "Y") {
        totalCess = products
          .filter((item) => item.item_tax !== "0.00" && item.item_tax != null)
          .reduce((sum, item) => {
            const itemSubtotal = parseFloat(item.subtotal) || 0;
            const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
            return sum + (itemSubtotal * itemCessRate) / 100;
          }, 0);
      }
      const grandTotal = totalstd + totalzeroGoods + totalTax + totalCess - over_all_amount - orderDiscount1;

      setTotalVal({
        totalstd,
        totalzeroGoods,
        totalTax,
        orderDiscount,
        orderDiscount1,
        over_all_discount,
        over_all_amount,
        grandTotal,
        totalCess: parseFloat(totalCess),
        totalstd_without_contract,
        totalzeroGoods_without_contract,
        totalTax_without_contract,
        totalstd_with_contract,
        totalzeroGoods_with_contract,
        totalTax_with_contract,
        discountedVatWithoutContract,
        totalDiscountOnVat,
        InvDiscount,
        totalWithoutContract,
      });
    } catch (err) {
      setOrderDetails(null);
      setProductDetails([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!accessToken) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }
    fetchInvoice();
  }, [orderId, accessToken]);

  const handleGenerateDeliveryNotePDF = (e, id) => {
    e?.preventDefault();
    if (accessToken === "tsc" || accessToken === "tss") printNewSalesInvoice_tsc(id);
    else if (accessToken === "knm") printNewSalesInvoice_knm(id);
    else if (accessToken === "sdm") printNewSalesInvoice_sdm(id);
    else if (accessToken === "rhv" || accessToken === "hv") printNewSalesInvoice_rhv(id);
    else if (accessToken === "atr") generateSummaryPDF_atr(id);
    else printNewSalesInvoice(id);
  };

  const handleGenerateQuotePDF = (e, id) => {
    e?.preventDefault();
    if (accessToken === "sdm") printNewQuoteInvoice_sdm(id);
    else printNewQuoteInvoice(id);
  };

  const isFreeRow = (row) => row.discount === "100.00" || row.discount === 100.0;
  const redSx = { color: "#f14240" };

  const footerRows = [
    { label: "Total VAT Goods", value: `${currencySymbol} ${(totalVal.totalstd || 0).toFixed(2)}` },
    { label: `${company_tax_type} Amount`, value: `${currencySymbol} ${(totalVal.totalTax || 0).toFixed(2)}` },
    ...(showCessRate === "Y" ? [{ label: "Cess Amount", value: `${currencySymbol} ${(totalVal.totalCess || 0).toFixed(2)}` }] : []),
    { label: "Total Zero VAT Goods", value: `${currencySymbol} ${(totalVal.totalzeroGoods || 0).toFixed(2)}` },
    { label: "Promotion Discount", value: `${currencySymbol} ${(totalVal.orderDiscount1 != null ? totalVal.orderDiscount1 : 0).toFixed(2)}` },
    { label: `Order Discount(${totalVal.over_all_discount || 0}%)`, value: `${currencySymbol} ${(totalVal.over_all_amount || 0).toFixed(2)}` },
    { label: "Invoice Total", value: `${currencySymbol} ${(totalVal.grandTotal != null ? totalVal.grandTotal : 0).toFixed(2)}` },
  ];

  const colCount = 7 + (showCessRate === "Y" ? 2 : 0);

  if (loading) {
    return (
      <>

        <Box className="page-container" sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
          <CircularProgress size={40} />
        </Box>
        <Footer />
      </>
    );
  }

  if (!orderDetails) {
    return (
      <>

        <Box className="page-container">
          <Paper className="paper-style">
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography color="text.secondary">Order not found</Typography>
              <Button component={Link} to="/Dashboard" variant="contained" sx={{ mt: 2 }}>
                Back
              </Button>
            </Box>
          </Paper>
        </Box>

      </>
    );
  }

  return (
    <>
      <Box className="page-container">
        <Paper className="paper-style">
          <Box sx={{ px: 2, py: 1.2 }}>
            <Grid2 container spacing={2} justifyContent="space-between" alignItems="center">
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography className="page-title">New Sales Invoice</Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }} sx={{ display: "flex", gap: 1, justifyContent: "flex-end", flexWrap: "wrap" }}>
                <Button
                  variant="contained"
                  size="small"
                  className="button-variant-contained"
                  startIcon={<Iconify icon="solar:printer-bold" width={16} />}
                  onClick={(e) => handleGenerateDeliveryNotePDF(e, orderId)}
                >
                  Print Invoice
                </Button>
                <Button
                  variant="outlined"
                  className="button-variant-outlined"
                  size="small"
                  startIcon={<Iconify icon="solar:printer-bold" width={16} />}
                  onClick={(e) => handleGenerateQuotePDF(e, orderId)}
                >
                  Print Quote
                </Button>
              </Grid2>
            </Grid2>
          </Box>

          <Box id="content-to-print" sx={{ px: 2, pb: 2 }}>
            <Grid2 container spacing={2} sx={{ mb: 2 }}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>{orderDetails.company}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {orderDetails.address}
                  <br />
                  {orderDetails.city}, {orderDetails.postal_code}, {orderDetails.country}
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>Tel: {orderDetails.phone}</Typography>
                <Typography variant="body2">Email: {orderDetails.email}</Typography>
                <Typography variant="body2">Customer A/C Number: {orderDetails.account_no}</Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography variant="body2"><strong>Order:</strong> INV{orderDetails.reference_no}</Typography>
                <Typography variant="body2"><strong>Order Date:</strong> {orderDetails.date}</Typography>
                <Typography variant="body2"><strong>Sale Status:</strong> {orderDetails.sale_status}</Typography>
                <Typography variant="body2"><strong>Route Number:</strong> {orderDetails.route_number}</Typography>
                <Typography variant="body2"><strong>Payment Status:</strong> {orderDetails.payment_status}</Typography>
              </Grid2>
            </Grid2>
            </Box>
            <TableContainer sx={{ maxHeight: "60vh", overflow: "auto" }}>
              <Table size="small" className="table-cell-border" >
                <TableHead>
                  <TableRow className="table-cell-header">
                    <TableCell width="30%">Description</TableCell>
                    {showCessRate === "Y" && <TableCell width="10%">HSN Code</TableCell>}
                    <TableCell align="center" width="10%">Quantity</TableCell>
                    <TableCell align="center" width="10%">Type</TableCell>
                    <TableCell align="right" width="10%">Unit Price</TableCell>
                    <TableCell align="right" width="10%">Discount</TableCell>
                    <TableCell align="right" width="10%">{company_tax_type} Amount</TableCell>
                    {showCessRate === "Y" && <TableCell align="right" width="10%">Cess Amount</TableCell>}
                    <TableCell align="right" width="10%">Net Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productDetails.map((row, index) => {
                    const free = isFreeRow(row);
                    const desc = `${row.product_code || ""} - ${row.product_name || ""} - ${row.size || ""} ${row.promo_product || ""}${row.free_product || ""}${row.ContractPrice || ""}`;
                    const itemDiscount = Number(row.item_discount) || 0;
                    const itemTax = Number(row.item_tax) || 0;
                    const cessAmt = showCessRate === "Y" ? ((parseFloat(row.subtotal) || 0) * (parseFloat(row.cess_rate_percent) || 0)) / 100 : 0;
                    return (
                      <TableRow key={index} sx={{ "& .MuiTableCell-root": { fontSize: "0.75rem", py: 0.75 } }}>
                        <TableCell sx={free ? redSx : {}}>{desc}</TableCell>
                        {showCessRate === "Y" && (
                          <TableCell sx={free ? redSx : {}} align="left">
                            {row.hsn_code?.trim() ? row.hsn_code : free ? "N/A" : "-"}
                          </TableCell>
                        )}
                        <TableCell align="center" sx={free ? redSx : {}}>{parseInt(row.quantity, 10)}</TableCell>
                        <TableCell align="center" sx={free ? redSx : {}}>{row.order_type}</TableCell>
                        <TableCell align="right" sx={free ? redSx : {}}>{currencySymbol} {row.unit_price || "0.00"}</TableCell>
                        <TableCell align="right" sx={free ? redSx : {}}>{currencySymbol} {itemDiscount.toFixed(2)}</TableCell>
                        <TableCell align="right" sx={free ? redSx : {}}>{currencySymbol} {itemTax.toFixed(2)}</TableCell>
                        {showCessRate === "Y" && <TableCell align="right" sx={free ? redSx : {}}>{currencySymbol} {cessAmt.toFixed(2)}</TableCell>}
                        <TableCell align="right" sx={free ? redSx : {}}>{currencySymbol} {row.subtotal ? parseFloat(row.subtotal).toFixed(2) : "0.00"}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                <TableFooter>
                  {footerRows.map((r, i) => (
                    <TableRow key={i} sx={{ "& .MuiTableCell-root": { fontSize: "0.75rem", py: 0.75, fontWeight: 500 } }}>
                      <TableCell colSpan={colCount - 1} align="right">{r.label}</TableCell>
                      <TableCell align="right">{r.value}</TableCell>
                    </TableRow>
                  ))}
                </TableFooter>
              </Table>
            </TableContainer>

            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", my: 2 }}>
              No claims for damages or short delivery will be considered unless made at the time of delivery of goods. These goods are not sold on a sale or return basis.
            </Typography>
    
        </Paper>
      </Box>
    </>
  );
};

export default NewSalesInvoice;
